import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import 'leaflet/dist/leaflet.css';
import LoadingComponent from './components/CommonComponent/LoadingComponent';
import { LoginComponent } from './components/LoginComponent';
import AppRoutes from './components/RouteComponents/AppRoutes';
import './index.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const App = () => {
  const queryClient = new QueryClient();
  return (
    <Suspense fallback={<LoadingComponent />} >
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={<LoginComponent />} />
          <Route path="/*" element={<AppRoutes />} />
          <Route path="*" element={<LoginComponent />} />
        </Routes>
      </QueryClientProvider>
    </Suspense>
  );
}

export default App;
